
import {defineComponent} from 'vue';
import MobileHead from "@/components/mobile/MobileHead.vue";
import CommonNews from "@/components/common/CommonNews.vue";
import MobileDeals from "@/components/mobile/MobileDeals.vue";
import MobileDiscover from "@/components/mobile/MobileDiscover.vue";
import MobileCashback from "@/components/mobile/MobileCashback.vue";
import CommonTestimonials from "@/components/common/CommonTestimonials.vue";
import MobilePay from "@/components/mobile/MobilePay.vue";
import MobileDownload from "@/components/mobile/MobileDownload.vue";
import CommonStart from "@/components/common/CommonStart.vue";

export default defineComponent({
    name: 'Mobile',
    components: {
        MobileHead,
        CommonNews,
        MobileDeals,
        MobileDiscover,
        MobileCashback,
        CommonTestimonials,
        MobilePay,
        MobileDownload,
        CommonStart
    },
});
